import React, { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { AuthUser } from '../../domains/Login/types/users'
import {
  canEditModule,
  canViewModule,
  getDefaultAuthorizedRoute,
} from '../../utils/moduleAccess'

interface ModuleAccessProps {
  user?: AuthUser
  code: string
  requiredPermission?: 'view' | 'edit'
  fallbackPath?: string
  children: ReactNode
}

const ModuleAccess = ({
  user,
  code,
  requiredPermission = 'view',
  fallbackPath,
  children,
}: ModuleAccessProps) => {
  const isAllowed =
    requiredPermission === 'edit'
      ? canEditModule(user, code)
      : canViewModule(user, code)

  if (!isAllowed) {
    const nextPath = fallbackPath || getDefaultAuthorizedRoute(user) || '/'
    return <Navigate to={nextPath} replace />
  }

  return <>{children}</>
}

export default ModuleAccess
